import { render } from "./about.vue?vue&type=template&id=43c0582c&scoped=true&ts=true"
import script from "./about.vue?vue&type=script&lang=ts"
export * from "./about.vue?vue&type=script&lang=ts"

import "./about.vue?vue&type=style&index=0&id=43c0582c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43c0582c"]])

export default __exports__